module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Date"},"es":{"label":"Fecha"},"fr":{"label":"Date"},"it":{"label":"Data"},"pt":{"label":"Data"},"pl":{"label":"Data"}}')
  delete Component.options._Ctor
}
